/**
 * 如果请求的url中包含了 sessionId
 * @param queryUrl
 */
import {UploadProps} from "ant-design-vue";
import {updateAvatar} from "@/api";
import {fixedFourNumber, fixedThreeNumber, fixedTwoNumber, fixedNumber, getNumberVal, StorageUtils, getUrlParams, GoingNewUtils} from 'xmgoing-utils';
import { CtlComEnum } from '@/main-page/enums/ctlComEnum';

export const BeanUtils={
  /**
   * 根据列生成新对象
   * @param orginRecord
   * @param colums
   */
  getNewObj(orginRecord,colums){
    const newObj={};
    colums.forEach((colItem)=>{
      newObj[colItem.propId]=orginRecord[colItem.propId]||'';
    })
    newObj['id']=orginRecord['id']||GoingNewUtils.getUUChar(32);
    return newObj;
  }
}

//获取小数位数
export const getPrecision=function (val:any,precision:any){
  if(parseInt(precision)===2){
    return fixedTwoNumber(val)
  }
  if(parseInt(precision)===3){
    return fixedThreeNumber(val)
  }
  if(precision==null||parseInt(precision)===0){
    return val
  }
  return fixedOneNumber(val);
}

interface IFormState {
  account: string | null;
  name: string | null;
  email: string | null;
  phone: number | null;
  avatar: string | null;
  password: string | null;
  roleId: string | null;
}
export const uploadUrl = (
  file: UploadProps['fileList'][number],
  formState: IFormState,
  setAvatarLoading: any,
) => {
  return new Promise((resolve, reject) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      reject('照片格式不正确');
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      reject('照片大小不能超过2MB');
      return;
    }
    // -->上传头像
    setAvatarLoading(true);
    const data = new FormData();
    data.append('file', file as any);

    updateAvatar(data)
      .then((res: any) => {
        const imgId = res[0].id;
        (formState.avatar as any) = imgId; //存储id
        setAvatarLoading(false);
        resolve(formState);
      })
      .catch(() => {
        setAvatarLoading(false);
        return false;
      });

    return false;
  });
};


/**
 * 获取当前列 是否可以编辑
 * @param cols
 * @param column
 */
export function getColIsCanEditor(cols, column,isEditorTable=false) {
  const eidtorCols = unref(cols).filter((colDb: any) => {
    if(colDb.isCanEditor==null&&isEditorTable){
        return  true
    }
    return colDb.isCanEditor === true;
  })
  unref(cols).forEach((colDb) => {
    if (colDb.children) {
      colDb.children.forEach((sonItem: any) => {
        if (sonItem.isCanEditor) {
          eidtorCols.push(sonItem);
        }
        if(sonItem.isCanEditor==null&&isEditorTable){
          eidtorCols.push(sonItem);
        }
      })
    }
  });
  const editorIds: any = [];
  eidtorCols.forEach((colDb: any) => {
    editorIds.push(colDb.propId);
  })
  return editorIds.includes(column.dataIndex)
}


export function loadSystem() {
  const projectI18n=getUrlParams("projectI18n",true);
  StorageUtils.addSessionItem("projectI18n", projectI18n || 'zh-CN');
  const sessionId=getUrlParams("sessionId",true)||StorageUtils.getSessionItem("sessionId");
  StorageUtils.addSessionItem("sessionId", sessionId);
  const curPageId=getUrlParams("id",true)||StorageUtils.getSessionItem("curPageId");
  StorageUtils.addSessionItem("curPageId", curPageId);

}

/** 表格单元格是否有可展示内容（0 等 false 数值仍应显示） */
export function hasGridCellDisplayValue(val: unknown): boolean {
  return val !== '' && val !== null && val !== undefined;
}

export const initContentByType=function (cellContent,showColType,showVal){
  if(unref(showColType)===CtlComEnum.NUMBER){
    showVal.value=getNumberVal(unref(cellContent));
    return
  }
  if(unref(showColType)===CtlComEnum.NUMBER_2){
    showVal.value=fixedTwoNumber(unref(cellContent));
    return
  }
  if(unref(showColType)===CtlComEnum.NUMBER_3){
    showVal.value=fixedThreeNumber(unref(cellContent));
    return
  }
  if(unref(showColType)===CtlComEnum.NUMBER_4){
    showVal.value=fixedFourNumber(unref(cellContent));
    return
  }
  if(unref(showColType)===CtlComEnum.NUMBER_5){
    showVal.value=fixedNumber(unref(cellContent), 5);
    return
  }
  showVal.value=getNumberVal(unref(cellContent));
}